import { Autocomplete } from "components";
import React, { useEffect, useState } from "react";
import DivisionalSecretariatServices from "services/DivisionalSecretariatServices";
/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const DivisionalSecretariatDropDown = ({
  name,
  label,
  value,
  onChange,
  filter = {},
  required = false,
  validators = [],
  errorMessages = [],
  ...rest
}) => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    limit: 1500,
    page: 0,
    search: null,
    status: "Active",
    ...filter, // Merge the passed filter prop
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [data] = await Promise.all([
          DivisionalSecretariatServices.getAll({
            ...filters,
            status: "Active",
          }),
        ]);
        console.log("Divisional Secretariat", data || []);

        setData(data?.data?.view?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [filters]);

  // Update filters when filter prop changes
  useEffect(() => {
    // Only update if district_id actually changed to prevent unnecessary API calls
    const newDistrictId = filter?.district_id;
    const currentDistrictId = filters.district_id;

    if (newDistrictId !== currentDistrictId) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ...filter,
      }));
    }
  }, [filter, filters.district_id]);

  return (
    <div>
      <Autocomplete
        name={name}
        label={label}
        value={
          (Array.isArray(value)
            ? data.filter((item) => value.includes(item.id))
            : data.find((item) => item.id === value)) || null
        } // Ensure value is an array of selected options
        onChange={(event, newValue) => {
          if (onChange) onChange(event, newValue);
        }}
        options={data}
        getOptionLabel={(option) => option.name || option.name || ""}
        textInputOnChange={(e) => {
          setFilters({ ...filters, search: e.target.value });
        }}
        //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
        required={required}
        validators={validators}
        errorMessages={errorMessages}
        TextFieldProps={{
          placeholder: "Select Divisional Secretariat",
        }}
        {...rest}
      />
    </div>
  );
};

export default DivisionalSecretariatDropDown;
